var _defs, _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import render from 'utils/render';
const SvgLivejasminModelMobile = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    ...props
  } = _ref;
  const Element = render.element(/*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "#fff"
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41 20",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _title || (_title = /*#__PURE__*/React.createElement("title", null, "lj_modelcenter_logo_mobile")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.08,0A9.78,9.78,0,0,1,40.8,2.58a.54.54,0,0,1,0,.78l-.75.75c-.22.28-.45.25-.72,0A8.43,8.43,0,0,0,34.05,2a7.88,7.88,0,0,0-7.75,8,7.87,7.87,0,0,0,7.75,8,8.11,8.11,0,0,0,5.31-2.08.51.51,0,0,1,.66-.08l.84.75c.22.16.16.55,0,.75A9.55,9.55,0,0,1,34.08,20a10,10,0,1,1,0-20Zm-30,0a.6.6,0,0,1,.47.28l6.45,12h.05l6.45-12A.6.6,0,0,1,18,0h.45a.53.53,0,0,1,.5.44l3.14,18.67a.51.51,0,0,1-.53.61H18.26a.57.57,0,0,1-.53-.44l-1.25-8.59h-.05l-4.67,9a.63.63,0,0,1-.47.31h-.5a.62.62,0,0,1-.48-.31l-4.69-9H5.56L4.34,19.28a.54.54,0,0,1-.53.44H.54A.51.51,0,0,1,0,19.11L3.15.44A.52.52,0,0,1,3.65,0Z"
  }))))));
  return /*#__PURE__*/React.createElement(Element.type, _extends({}, Element.props, {
    ref: ref
  }), children, Element.props.children);
});
export default /*#__PURE__*/React.memo(SvgLivejasminModelMobile);